module.exports = __webpack_public_path__ + "static/img/douyin.19890bcc.png";